import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import useStateRef from 'react-usestateref';
//import MobileHeaderNavTabContainer from './MobileHeaderNavTabContainer';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import MobileNavMenu from './MobileNavMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchValueAction } from '../../middleware/getSearchValueAction';
import { Modal } from '../Modal/Modal';
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import CommonTiles from '../CommonTiles';

function MobileHeaderNavContainer({ miniCartItemsCount, miniCartItems, profile, navMenu, targerter, productSearchPageUrl, searchQuery, setMenuOverlay, headerLogo, tileMenu, topRibbenMenu }) {
    const [autoSuggestionResult, setAutoSuggestionResult] = useState("")
    const [openmenu, setOpenMenu] = useState(true);
    const location = useLocation();
    const fullPathMobile = location.pathname + location.search;
    const childRules = navMenu?.ContentFolderZone?.[0]?.childRules;
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [searchValue, setSearchValue, searchValueRef] = useStateRef("")
    const [defaultSearchValue, setDefaultSearchValue, defaultSearchValueRef] = useStateRef(searchQuery ? searchQuery : "")
    const [productSearchPageUrlState, setProductSearchPageUrlState] = useState(productSearchPageUrl ? productSearchPageUrl : "browse/product-search-results");
    const [search, setSearch, searchRef] = useStateRef("");
    const history = useHistory()
    const dispatch = useDispatch();
    const searchValues = useSelector(state => state.getSearchValue.searchValue)
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)

    const popoverRef = useRef(null);
    const handleLogOut = (event) => {
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/logout`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    window.location.href = "/"
                } else {
                    const error = res._ERROR_MESSAGE_;
                }
            })
    };

    // useEffect(() => {
    //     console.log("my-account-mobile",document.getElementById("my-account-mobile"))
    //     if (profileDetails && profileDetails.userTypeCheck && Object.keys(profileDetails.userTypeCheck).length > 0 && !profileDetails.userTypeCheck.showAccount && profileDetails.userSegment['Punchout Session'] === true) {
    //         console.log("my-account-mobile 123",document.getElementById("my-account-mobile"))
    //         if(document.getElementById("my-account-mobile")) {
    //             document.getElementById("my-account-mobile").classList.remove("d-block")
    //             document.getElementById("my-account-mobile").classList.add("d-none")
    //         }
            
    //     }

    // }, [profileDetails])
    useEffect(() => {
        setSearch(window.location.search)

    }, [])


    const handleMenuCancel = (event) => {
        event.preventDefault();
        setOpenMenu(!openmenu)
        var open = document.getElementById("shopByCategory");
        const divs = document.querySelectorAll("div[wrap-content]");
        if (openmenu) {
            open.classList.remove("d-none");
            for (const div of divs) {
                const wrapContentValue = div.getAttribute("wrap-content");
                if (wrapContentValue !== "HeaderContent" && !div.classList.contains('overylay-open')) {

                    div.classList.add('overylay-open');
                }
            }
        } else {
            open.classList.add("d-none");
            for (const div of divs) {
                const wrapContentValue = div.getAttribute("wrap-content");
                if (wrapContentValue !== "HeaderContent" && div.classList.contains('overylay-open')) {
                    div.classList.remove('overylay-open');
                }
            }
        }

    }

    useEffect(() => {
        if ((window.innerWidth > 991)) {
            setIsPopoverOpen(false);
        }
    }, []);

    const handlePopoverToggle = (event) => {
        event.preventDefault();
        if (window.innerWidth <= 991) {
            setIsPopoverOpen(!isPopoverOpen);
        }
    };


    useEffect(() => {
        window.addEventListener('click', function (e) {
            //if (props.containerObject && props.containerObject.attributes.isCheckOutPage != "Y") {
            var taEle = document.getElementById('ta-mobile');
            if (taEle && taEle.contains(e.target)) {
                // Clicked in box
            } else {
                // Clicked outside the box
                setAutoSuggestionResult("")
                //setSearchProductDetails("")
            }
            //}
        });
    }, [])

    useEffect(() => {
        const handleCloseButtonClick = (event) => {
            if (event.target && event.target.matches('.btn-close')) {
                setIsPopoverOpen(false);
            }
        };

        const currentPopover = popoverRef.current;
        if (currentPopover) {
            currentPopover.addEventListener('click', handleCloseButtonClick);
        }

        // Clean up event listener on unmount or when content changes
        return () => {
            if (currentPopover) {
                currentPopover.removeEventListener('click', handleCloseButtonClick);
            }
        };
    }, [isPopoverOpen]);

    const handleSearchAutoSuggestion = (event) => {
        let keyword = event.target.value;
        setSearchValue(encodeURI(keyword))
        setDefaultSearchValue(keyword)
        dispatch(getSearchValueAction(keyword))
    }

    useEffect(() => {
        if (searchValues) {
            setDefaultSearchValue(searchValues)
        }
    }, [searchValues])

    useEffect(() => {
        let params = new URLSearchParams(searchRef.current)
        if (params.get("tab") === null && searchQuery === "" && searchValueRef.current === "") {
            dispatch(getSearchValueAction(""))
            setDefaultSearchValue("")
        } else {
            if (params.get("q")) {
                setDefaultSearchValue(params.get("q"))
            }
        }
    }, [])

    useEffect(() => {
        setAutoSuggestionResult("")
        if (searchValueRef.current && searchValueRef.current.length >= 3) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/static/fetch-suggestions-for-global-search/${searchValueRef.current}`,
                { method: "GET" }
            ).then((res) => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setAutoSuggestionResult(res.response)
                        dataLayerAutocomplete(searchValueRef.current, res.dataLayerResponse)
                    } else if (res.result == "error") {
                        console.log("error", res.response)
                    }
                })
        } else {
            setAutoSuggestionResult("")
        }
    }, [searchValueRef.current])

    function dataLayerAutocomplete(searchTerm, sugg) {
        //console.log("dataLayerAutocomplete");
        window.dataLayer = window.dataLayer || []
        if (window.dataLayer.length > 0) {
            window.dataLayer.push({
                "event": "type_ahead",
                "search_term": searchTerm,
                "suggestions": sugg
            });
        }
    }


    function handleSubmitData(event) {
        event.preventDefault()
        var formData = new FormData(event.target);
        var check = formData.get("q");
        if (check != "" && check.length >= 1) {
            var encodeQueryStr = encodeURIComponent(check)
            setDefaultSearchValue(check)
            window.location.href = "/" + productSearchPageUrlState + "?q=" + encodeQueryStr + "&product.type=Product&tab=p"
        }
    }
    const handleShoppingListClick = (event) => {
        event.preventDefault();
        dispatch(redirectUrlAction("/account/list"))
        if (profile && profile.transient) {
            history.push("/account/login?resume=list")
        } else {
            history.push("/account/list")
        }
    }
    const handleMyAccountClick = (event) => {
        event.preventDefault();
        dispatch(redirectUrlAction("/account/landing"))
        if (profile && profile.transient) {
            history.push("/account/login")
        } else {
            history.push('/account/landing')
        }
    }
    return (
        <div className='cbHeader'>
            <Modal newListModalId="newListModal" />
            <div className='row pb-1 header-mobile-padding '>
                <div className="col-6 logo">
                    <Link to="/" title="Carolina Biological Supply logo">
                        <img fetchpriority="high" src={`/images/logo.svg`} alt="Carolina Biological Supply" />
                    </Link>
                </div>
                <div className='col-6 d-block d-lg-none'>

                    <ul className='mobile-menu list-group list-group-horizontal c-utility-nav utility-nav-list float-end'>
                        <CommonTiles profile={profile}
                            miniCartItemsCount={miniCartItemsCount}
                            miniCartItems={miniCartItems}
                            targerter={targerter}
                            // handleAccountLogin={handleAccountLogin}
                            handleLogOut={handleLogOut}
                            //handleListLogin={handleListLogin}
                            //shoppingListDetailRef={shoppingListDetailRef.current}
                            menuTile={topRibbenMenu?.ContentFolderZone?.[0]?.childRules ?? []}
                        />
                    </ul>



                    {/* <ul className='list-group list-group-horizontal c-utility-nav utility-nav-list float-end'>
                        <li id="my-account-mobile" className='text-center list-group-item utility-nav-label'>
                            <Link className='link-icon-style' to={`${profile && profile.transient ? "/account/login" : "/account/landing"}`}>
                                <i className="bi bi-person d-block d-lg-none"></i>
                                <span className='d-block'>Account</span></Link>
                        </li>
                        <li className={`text-center list-group-item ${isPopoverOpen ? 'contact' : ''} utility-nav-label `}>
                            <Link className='link-icon-style' onClick={handlePopoverToggle}>
                                <i className="bi bi-chat text-center d-block d-lg-none"></i>
                                <span className='d-block'>Support</span>
                            </Link>
                            <div className={`c-utility-nav-content checkout-service-support ${isPopoverOpen ? 'open' : ''}`}
                                dangerouslySetInnerHTML={{ __html: targerter ? targerter : '' }} ref={popoverRef} >
                            </div>
                        </li>
                        <li className='text-center list-group-item utility-nav-label'>
                            <Link className='link-icon-style' to="/checkout/cart">
                                <i className="bi bi-cart d-block d-lg-none"></i>
                                <span className='d-block'>Cart</span></Link>
                            <span className="c-utility-nav-cart-qty">
                                <div id="minicartCount">{miniCartItemsCount ? miniCartItemsCount : 0}</div>
                            </span>
                        </li>
                    </ul> */}
                </div>
            </div>
            <nav aria-label='mobile-main-navigation'>
            <div className={`d-lg-none d-flex search-color ${fullPathMobile === '/account/login?resume=prev' || fullPathMobile === '/account/login' ||
                fullPathMobile === '/account/forgotPassword?resume=prev' || fullPathMobile === '/account/forgotPassword' || fullPathMobile === '/account/login?DPSLogout=true' ? 'd-none' : 'd-block'}`}>
                <div className="navbar navbar-mobile-search">
                    <button className="header-menu-open--btn" type="button" id="menu-id" onClick={handleMenuCancel}  >
                        {openmenu === true ? <span className='d-flex text-white ' id='menu-open'><i className="bi bi-list"></i><span className='my-auto ms-1 font-menu'>MENU</span></span>
                            : <span className='d-flex text-white ' id="menu-close"><i className="bi bi-x-lg"></i><span className='my-auto ms-1 font-menu'>MENU</span></span>
                        }
                    </button>
                </div>
                <form className="w-100 me-1 my-1 d-flex " onSubmit={handleSubmitData}>
                    <div className="predictive__search--form " >
                        <label className='input-focus-search'>
                            <span className='search-icon-mobile'>
                                <i className="bi bi-search d-lg-none "></i>
                            </span>
                            <input type="search" id="q" size="100" name="q" placeholder="Search by Keyword or item #" className="predictive__search--input-calolina form-control global-search"
                                onChange={handleSearchAutoSuggestion} maxlength="100" value={defaultSearchValueRef.current ? defaultSearchValueRef.current : ""} />
                            <button className="btn btn-primary d-none d-lg-block" type="submit" id="search-submit" value="Search"></button>
                        </label>
                    </div>
                </form>
            </div>

            <div className={`col-md-12 col-12 ta-results ${autoSuggestionResult && autoSuggestionResult.length > 0 ? "" : "d-none"}`}>
                <div id="ta-mobile" className={`col-md-5 ms-0 col-9 ${autoSuggestionResult ? "" : "d-none"}`}>
                    <p className='bw'>Products suggessions: </p>
                    <div className=''>
                        {autoSuggestionResult ? autoSuggestionResult.map((product) => {
                            return (<>
                                <span id="ta-suggession" className="sugg1">
                                    <ul className="sugg2">
                                        <Link className="search-autocompleted" to={product.productUrl ? product.productUrl : ""} dangerouslySetInnerHTML={{ __html: product.productName ? product.productName : product.productSeoName ? product.productSeoName : "" }}></Link>
                                    </ul>
                                </span>
                            </>)
                        }) : ""}
                        <div className='col-12 see-all-suggestion'>
                            <Link className="btn-primary" to={`/${productSearchPageUrlState}?q=` + encodeURIComponent(searchValueRef.current) + `&product.type=Product&tab=p`}>See All Results</Link>
                        </div>
                    </div>

                </div>
            </div>

            <div className='d-none c-menu-category row' id="shopByCategory">
                <div className='d-block w-100 c-menu-category-list'>
                    <div className="accordion color-catagory label-child px-0" id='catagory-collapse' >
                        {childRules && childRules.map((rule, index) => (
                            <MobileNavMenu
                                key={index}
                                index={index}
                                rule={rule} />

                        ))}
                        <ul className='list-unstyled catagory-items-mobile'>
                            <li><Link className='text-decoration-none' onClick={handleMyAccountClick}>My Account</Link></li>
                            {profile && profile.transient ? "" : <li><Link className='text-decoration-none' onClick={handleLogOut}>Log Out</Link></li>}
                            <li><Link className='text-decoration-none' to="/help/contact-us">Service & Support</Link></li>
                            <li><Link className='text-decoration-none' onClick={handleShoppingListClick}>Shopping Lists</Link></li>
                            <li><Link className='text-decoration-none' to="/catalogs/quickorder" >Quick Order</Link></li>
                            <li><Link className='text-decoration-none' to="/help/service-and-support" >Help</Link></li>
                            <li><Link className='text-decoration-none' to="/our-company/about-us">Our Company</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            </nav>
        </div>
    )
}

export default MobileHeaderNavContainer
